import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';

function RaceDetailHeader({ raceDate, surfaceLabel, roughness, raceConfidence, stats }) {
  return (
    <Box className="race-detail-panel race-detail-header">
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {raceDate && (
          <Chip className="race-detail-chip" label={raceDate} variant="outlined" />
        )}
        {surfaceLabel && (
          <Chip className="race-detail-chip" label={surfaceLabel} variant="outlined" />
        )}
        {roughness && (
          <Chip className="race-detail-chip" label={`荒れ度 ${roughness}`} variant="outlined" />
        )}
        {raceConfidence?.label && (
          <Chip
            className={`race-detail-chip race-detail-chip-confidence-${raceConfidence.tone}`}
            label={`AI自信度 ${raceConfidence.label}`}
            variant="outlined"
          />
        )}
      </Stack>

      <Box className="race-detail-stat-grid">
        {stats.map((stat) => (
          <Box key={stat.label} className="race-detail-stat-card">
            <Typography className="race-detail-stat-label">{stat.label}</Typography>
            <Typography className="race-detail-stat-value">{stat.value}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default RaceDetailHeader;
